import { Box, styled } from '@mui/material';
import { APPROVAL_SECTION_GAP } from '@/components/Approval/@components/InfoSection';

export const AttendanceSlotRoot = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${APPROVAL_SECTION_GAP}px;
`;
